import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import onClickOutside from 'react-onclickoutside'
import { ModalTitle } from 'app/common/modals'
import { H4, Text } from 'app/common/typography'
import { ButtonMedium, media } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'

type Props = {
    messageKey?: string,
    firstname?: string,
    handleClose: () => void,
    handleDelete: () => any
}

class DeleteModalComponent extends Component<Props> {
    /* Manage clickOutside Modal to close it */
    handleClickOutside(e) {
        const { handleClose } = this.props
        handleClose()
    }

    delete = () => {
        const { handleClose, handleDelete } = this.props
        handleDelete()
        handleClose()
    }

    render() {
        const { handleClose, messageKey, firstname = '' } = this.props
        const { red, yellow } = colors
        return (
            <Container>
                <ModalTitle
                    center
                    handleClose={handleClose}
                    titleNode={
                        <FormattedMessage id="form.delete.title">
                            {(text: string) => <StyledH4>{text}</StyledH4>}
                        </FormattedMessage>
                    }
                />
                {messageKey && (
                    <FormattedMessage
                        id={messageKey}
                        values={{ name: firstname }}>
                        {(text: string) => (
                            <Paragraph center>
                                <Text>{text}</Text>
                            </Paragraph>
                        )}
                    </FormattedMessage>
                )}
                <StyledButtonMedium onClick={handleClose} background={yellow}>
                    <FormattedMessage id="form.delete.button.cancel" />
                </StyledButtonMedium>
                <StyledButtonMedium onClick={this.delete} background={red}>
                    <FormattedMessage id="form.delete.button.submit" />
                </StyledButtonMedium>
            </Container>
        )
    }
}

const StyledH4 = styled(H4)`
    text-align: center;
`

const Container = styled.div`
    padding: 20px;
    ${media.medium`
        padding: 40px;
        margin: auto;
    `};
`

const StyledButtonMedium = styled(ButtonMedium)`
    align-self: center;
    width: 100%;
    margin-top: 20px;
    border: none;
`

const Paragraph = styled.p`
    ${props => (props.center ? 'text-align: center' : '')};
`

const DeleteModal = onClickOutside(DeleteModalComponent)

export { DeleteModal }
